import { render, staticRenderFns } from "./SpendByProject.vue?vue&type=template&id=01ed55f2&scoped=true&"
import script from "./SpendByProject.vue?vue&type=script&lang=js&"
export * from "./SpendByProject.vue?vue&type=script&lang=js&"
import style0 from "./SpendByProject.vue?vue&type=style&index=0&id=01ed55f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed55f2",
  null
  
)

export default component.exports